import { createContext } from 'react'

export const UserContext = createContext({})

export interface IUserContextType {
  step
  nextStep
  showErr
  isLoading
  storeToken
  setStep
  frSessionTimeout
  setStoreToken
  env
  userInputError
  setIsLoading
  selectedOTPChannel
  setSelectedOTPChannel
  otpSupport
  setOtpSupport
  pingTokenTimeout
}
